import React from "react";
import * as MuiMaterial from "@mui/material";

export default function FormSection({ children, title, fontVariant }) {
  return (
    <MuiMaterial.Stack spacing={{ xs: 3, md: 2 }} sx={{ width: "100%" }}>
      <MuiMaterial.Typography variant={fontVariant ?? "h6"}>
        {title}
      </MuiMaterial.Typography>
      {children}
    </MuiMaterial.Stack>
  );
}
